import axios from "axios";
import Config from "../../config/";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: { Authorization: API_KEY + localStorage.getItem("token") }
  };
}

export function fetchAnswer() {
  const url = `${ROOT_URL}questionnaire/questionnaire/`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function pushAnswer(body) {
  const url = `${ROOT_URL}questionnaire/questionnaire/`;

  const fdata = new FormData();
  fdata.append('q1', body.q1);
  fdata.append('q2', body.q2);
  fdata.append('q3', body.q3);
  fdata.append('q4', body.q4);
  fdata.append('q5', body.q5);
  fdata.append('q6', body.q6);
  fdata.append('q7', body.q7);
  fdata.append('q8', body.q8);
  fdata.append('q9', body.q9);
  fdata.append('q10', body.q10);
  fdata.append('t1', body.t1);
  fdata.append('t2', body.t2);
  fdata.append('t3', body.t3);
  fdata.append('t4', body.t4);
  fdata.append('t5', body.t5);
  fdata.append('t6', body.t6);
  fdata.append('t7', body.t7);
  fdata.append('t8', body.t8);
  fdata.append('t9', body.t9);
  fdata.append('t10', body.t10);

  let score1 = 0;
  let score2 = 0;
  if(body.q1 == "Automatic Identification System"){
    score1 = score1 + 1;
  }
  if(body.q2 == "VHF"){
    score1 = score1 + 1;
  }
  if(body.q3 == "Both of the above"){
    score1 = score1 + 1;
  }
  if(body.q4 == "Zoom In"){
    score1 = score1 + 1;
  }
  if(body.q5 == "Route"){
    score1 = score1 + 1;
  }
  if(body.q6 == "Both of the above"){
    score1 = score1 + 1;
  }
  if(body.q7 == "Divider"){
    score1 = score1 + 1;
  }
  if(body.q8 == "Center On"){
    score1 = score1 + 1;
  }
  if(body.q9 == "Connection Wizard"){
    score1 = score1 + 1;
  }
  if(body.q10 == "User Guide"){
    score1 = score1 + 1;
  }

  if(body.t1 == "1"){
    score2 = score2 + 1;
  }
  if(body.t2 == "1"){
    score2 = score2 + 1;
  }
  if(body.t3 == "0"){
    score2 = score2 + 1;
  }
  if(body.t4 == "0"){
    score2 = score2 + 1;
  }
  if(body.t5 == "1"){
    score2 = score2 + 1;
  }
  if(body.t6 == "1"){
    score2 = score2 + 1;
  }
  if(body.t7 == "0"){
    score2 = score2 + 1;
  }
  if(body.t8 == "0"){
    score2 = score2 + 1;
  }
  if(body.t9 == "1"){
    score2 = score2 + 1;
  }
  if(body.t10 == "1"){
    score2 = score2 + 1;
  }

  fdata.append('score1', score1);
  fdata.append('score2', score2);

  const request = axios.post(url, fdata, cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
  return request;
}
